import { useMemo } from 'react';

import type { LinkPickerPlugin } from '@atlaskit/link-picker';
import {
	type AtlassianLinkPickerPluginConfig,
	Scope,
	useAtlassianPlugins,
} from '@atlassian/link-picker-atlassian-plugin';

/**
 * Returns the set of Atlassian link picker plugins to use when adding sources
 * to a Rovo Space. Covers Confluence, Jira, Atlas (Townsquare) and Loom.
 */
export function useSpaceSourcePlugins(cloudId: string): LinkPickerPlugin[] {
	const configs = useMemo<AtlassianLinkPickerPluginConfig[]>(
		() => [
			{
				tabConfig: { tabKey: 'confluence', tabTitle: 'Confluence' },
				products: ['confluence'],
				scope: Scope.ConfluenceContentType,
				cloudId,
			},
			{
				tabConfig: { tabKey: 'jira', tabTitle: 'Jira' },
				products: ['jira'],
				scope: Scope.JiraIssueDashboardBoardProjectFilter,
				cloudId,
			},
			{
				tabConfig: { tabKey: 'atlas', tabTitle: 'Atlas' },
				products: ['townsquare'],
				scope: Scope.TownsquareProject,
				cloudId,
			},
			{
				tabConfig: { tabKey: 'loom', tabTitle: 'Loom' },
				products: ['loom'],
				scope: Scope.Loom,
				cloudId,
				disableActivityClient: true,
			},
		],
		[cloudId],
	);
	return useAtlassianPlugins(configs);
}
